class TestModeStorage {
  private readonly TEST_MODE_KEY = 'testMode'

  public getTestMode(): boolean {
    try {
      return localStorage.getItem(this.TEST_MODE_KEY) === 'true'
    } catch (error) {
      console.error('Ошибка при чтении режима тестирования:', error)
      return false
    }
  }

  public setTestMode(enabled: boolean): void {
    try {
      localStorage.setItem(this.TEST_MODE_KEY, String(enabled))
    } catch (error) {
      console.error('Ошибка при сохранении режима тестирования:', error)
    }
  }
}

export const testModeStorage = new TestModeStorage()
